<template>
    <v-layout row>
        <v-flex xs12>
            <router-view/>
            <v-tabs v-if="customer.sales_years && customer.sales_years.length > 0"
                    centered light
                    slider-color="primary">
                <v-tab
                        v-for="sales_year in customer.sales_years"
                        :key="sales_year.toString()"
                        :value="`tab-${sales_year}`"
                        @click="changeTab(sales_year.toString())"
                        @changed="changeTab(sales_year.toString())"
                >
                    {{ sales_year.toString()}}
                </v-tab>
                <v-tab-item
                        v-for="sales_year in customer.sales_years"
                        :key="sales_year.toString()"
                >
                    <v-list
                            v-for="sale in transactions"
                            :key="sale.id"
                            two-line>
                        <v-list-tile @click="goToDetail(sale.id)">
                            <v-list-tile-action class="primary">
                                <v-list-tile-title class="text-xs-center subheading text-lowercase white--text">
                                    {{sale.month}}
                                </v-list-tile-title>
                                <v-list-tile-title class="text-xs-center title font-weight-bold white--text">
                                    {{sale.day}}
                                </v-list-tile-title>
                            </v-list-tile-action>

                            <v-list-tile-content class="mr-2 ml-2">
                                <v-list-tile-title>{{sale.store}}</v-list-tile-title>
                                <!-- @modified ana.castro 2019.11.25 SCLAPP-23: the purchase resume must display the purchases' total value and not the document's identifier-->
                                <!-- <v-list-tile-sub-title> {{ sale.document_identifier}}</v-list-tile-sub-title>-->
                                <v-list-tile-sub-title>{{sale.total}}&nbsp;{{sale.currency}}</v-list-tile-sub-title>
                            </v-list-tile-content>

                            <v-list-tile-action v-if="sale.loyalty_points > 0">
                                <v-list-tile-title class="secondary--text text-xs-center headline font-weight-bold">
                                    {{sale.loyalty_points}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title class="secondary--text text-xs-center text-lowercase"> {{
                                    $vuetify.t('$vuetify.points') }}
                                </v-list-tile-sub-title>
                            </v-list-tile-action>
                        </v-list-tile>

                    </v-list>
                    <mugen-scroll :handler="getNextTransactions" :should-handle="!loading && hasMoreResults">
                        <!-- Verifying the flag which defines whether or not there are more results to load -->
                        <p v-if="loading">...</p>
                    </mugen-scroll>
                </v-tab-item>
            </v-tabs>
            <v-layout v-else align-center justify-center column>
                <v-spacer class="my-4"></v-spacer>
                <v-icon style="font-size: 150px">fal fa-shopping-cart</v-icon>
                <v-spacer class="my-4"></v-spacer>
                <h2 class="title text-xs-center">{{ $vuetify.t('$vuetify.no_movements_to_display') }}</h2>
            </v-layout>

        </v-flex>
        <v-btn
               fixed
               fab
               bottom
               right
               color="primary"
               @click="goToLoyaltyMovements()">
            <v-icon>fal fa-history</v-icon>
        </v-btn>
    </v-layout>
</template>

<script>
    import {purchasesService, userService} from '../../_services'
    import {getErrorMessage, getUrlParams} from '../../_helpers'
    import MugenScroll from 'vue-mugen-scroll'

    export default {
        name: "Purchases",
        components: {MugenScroll},
        data() {
            return {
                loading: false,
                hasMoreResults: true,
                nextPageUrl: null,
                transactions: [],
                customer: {}
            }
        },
        methods: {
            //This function is triggered every time the user changes the displayed Tab.
            // It aims at loading the Customer's transactions for the year represented on the Tab.
            //The Customer's transactions are stored on the  Transactions' Array initialized on the data()
            changeTab: function (year) {
                if (year) {
                    purchasesService.getAll({year: year}).then(result => {
                            this.nextPageUrl = result.next;
                            this.hasMoreResults = this.nextPageUrl !== undefined;
                            this.transactions = result.results;
                        },
                        // eslint-disable-next-line
                        error => {
                            this.$store.dispatch("loader/setLoading", false);
                            this.$store.dispatch("alert/error", this.$vuetify.t('$vuetify.generic_error'));
                        }
                    );
                }
            },
            //This function is triggered when the user selects a Transaction to access its detail;
            // this works as a redirect to the Transaction's detail interface
            goToDetail: function (pk) {
                this.$router.push({name: 'purchases-detail', params: {id: pk}})
            },
            //This function is triggered by the infinite slider. By default, only 7 transactions are displayed,
            // when the user has more than 7 transactions and scrolls on the interface,
            // this GET is triggered to obtain the following 7 transactions and append them to the Transactions' Array
            getNextTransactions() {
                //Setting the loading flag to true
                this.loading = true;
                //Verifying there are more Transactions to fetch
                if (this.nextPageUrl !== null) {
                    this.$store.dispatch("loader/setLoading", true);

                    purchasesService.getAll(getUrlParams(this.nextPageUrl)).then(result => {
                            //Adding the fetched transactions to the existing list of transactions
                            this.transactions = this.transactions.concat(result.results);
                            this.loading = false;
                            //Updating the URL which retrieves the following 7 transactions
                            // (it has a page=X which helps on this process)
                            // When there are no more Transactions to fetch, the URL is set to NULL and the flag which
                            // states whether or not the word "loading" should be displayed is set to false
                            this.nextPageUrl = result.next;
                            this.hasMoreResults = this.nextPageUrl !== undefined;
                            this.$store.dispatch("loader/setLoading", false);
                        },
                        error => {
                            getErrorMessage(error, 'Getting the Transactions', this);
                        }
                    );
                } else
                    this.loading = false
            },
            goToLoyaltyMovements() {
                this.$router.push({name: 'loyaltymovements'})
            },
        },
        mounted() {
            userService.get().then(data => this.customer = data);
        },
        watch: {
            // Every time the customer yields a different result (the first time we enter this page)
            // the function which loads values for the first tab is called.
            // The aim is to get all the purchases the customer had during the most recent year;
            //  if the customer has no "sales_years" then the service to get the data should not be called
            customer: function () {
                if (this.customer !== undefined) {
                    if (this.customer.sales_years[0]) {
                        this.changeTab(this.customer.sales_years[0]);
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .v-list__tile__sub-title i {
        padding-right: 5px;
    }

    .v-card-actions i {
        padding-right: 5px;
    }
</style>
